import { memo } from "react";
import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";
import ChatAppContent from "./ChatAppContent";

function ChatApp() {
  return (
    <div className="content" sx={{ clear: "left" }}>
      <TemplatePage type={"chatApp"}>
        <ChatAppContent />
      </TemplatePage>
    </div>
  );
}

export default memo(ChatApp);
